import React, { FC, useMemo } from 'react';
import { ReactTable, CheckboxInput } from '@td-client-frontend/common';
import { ClientRepsUser } from '../../@types/Users';
import { useAuth } from '../../context/AuthContext';

interface ManageUsersTableProps {
  usersData: ClientRepsUser[];
  onUserManage: (userId: string) => void;
  isFetching: boolean;
  checkedUsers: string[];
  onMainCheck: () => void;
  onUserCheck: (checked: boolean, userId: string) => void;
}

const ManageUsersTable: FC<ManageUsersTableProps> = ({
  usersData,
  onUserManage,
  isFetching,
  checkedUsers,
  onMainCheck,
  onUserCheck
}) => {
  const { checkPerm } = useAuth();
  const readOnly = !checkPerm('UserWrite');
  const usersColumn = useMemo(() => {
    const isAllRolesSelected: boolean = !!(usersData.length && usersData.length === checkedUsers.length);
    return [
      {
        id: 'mainCheckbox',
        Header: <CheckboxInput checked={isAllRolesSelected} onChange={onMainCheck} />,
        isVisible: !readOnly,
        width: '4',
        Cell: ({
          row: {
            original: { id }
          }
        }) => {
          const isCheckedUser: boolean = checkedUsers.includes(id);
          return (
            <div className="w-10">
              <CheckboxInput
                checked={isCheckedUser}
                onChange={() => onUserCheck(isCheckedUser, id)}
                disabled={undefined}
              />
            </div>
          );
        }
      },
      {
        Header: 'First Name',
        accessor: 'firstNm'
      },
      {
        Header: 'Last Name',
        accessor: 'lastNm',
        disableSortBy: true
      },
      {
        Header: 'User Name',
        accessor: 'userNm',
        disableSortBy: true
      },
      {
        Header: 'Role',
        accessor: 'roleNm',
        disableSortBy: true
      },
      {
        Header: 'Status',
        accessor: 'active',
        disableSortBy: true,
        Cell: ({
          row: {
            original: { active }
          }
        }) => {
          return active ? <span>Active</span> : <span>Inactive</span>;
        }
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        disableSortBy: true,
        Cell: ({
          row: {
            original: { id }
          }
        }) => {
          return (
            <button className="flex text-primary-500 hover:text-primary-70" onClick={() => onUserManage(id)}>
              {readOnly ? 'View' : 'Manage'}
            </button>
          );
        }
      }
    ];
  }, [usersData.length, checkedUsers, onMainCheck, onUserCheck, onUserManage, readOnly]);
  return <ReactTable data={usersData} columns={usersColumn} isFetching={isFetching} getSortBy manualSortBy />;
};

export default ManageUsersTable;
